<template>
  <div class="container-main">
    <bannerVideo bg="#949590" videoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/ms_ssLive.mp4" allVideoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/ms_ssLive-all.mp4" title="双师课" message="魔法校老师授课，机构老师在教室指导学生课中学习+课后在线家辅"></bannerVideo>
    <teacherTeam bg="#F8F9FD" :main="teamConfig.main" :sub="teamConfig.sub" :typeName="teamConfig.typeName" :typeTitle="teamConfig.typeTitle" :teacherUrl="teamConfig.teacherUrl" :typeDes="teamConfig.typeDes"></teacherTeam>
    <supportTeacher main="辅导老师教室内全程伴学" :imgW="435" :imgH="276"  sub='让每个孩子都能受到关注' :configList="supportLiveList"></supportTeacher>
    <littleBig bg="#F8F9FD" :isLive="true" main="双师模式对比传统面授的优势" sub="更优质的授课内容，更稳定的授课团队，更有趣的授课方式"></littleBig>
    <oneImg :main="hardWare.main" :sub="hardWare.sub" :imgUrl="hardWare.imgUrl" :imgW="hardWare.imgW" :imgH="hardWare.imgH"></oneImg>
    <cloudLearn bg="#F8F9FD"></cloudLearn>
    <subjectIntro :hasSub="hasSub"></subjectIntro>
    <supportTeacher bg="#F8F9FD" main="机构运作全链条运营支持"  :imgW="435" :imgH="276" sub='招生+续费，校长+老师培训，让机构健康成长' :configList="liveOperateList"></supportTeacher>
  </div>
</template>
<script>
import teacherTeam from './components/techerTeam'
import bannerVideo from './components/bannerVideo/bannerVideo'
import supportTeacher from './components/supportTeacher'
import littleBig from './components/litteBig'
import cloudLearn from './components/cloudLearn'
import subjectIntro from './components/subject-intro'
import oneImg from './components/oneImg'
import { ssLiveTeacherTeam, supportLiveList, liveOperateList } from '@/const/index'
export default {
  data () {
    return {
      teamConfig: ssLiveTeacherTeam,
      hasSub: [1, 2, 3, 4, 5, 6],
      supportLiveList: supportLiveList,
      liveOperateList: liveOperateList,
      hardWare: {
        imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/live-equipment.png',
        imgW: 890,
        imgH: 556,
        main: '自有硬件稳定有保障',
        sub: 'T-Box 第一款专为智能教学打造的AI终端'
      }
    }
  },
  components: { bannerVideo, teacherTeam, supportTeacher, littleBig, cloudLearn, subjectIntro, oneImg }
}
</script>
